'use client'

import * as React from 'react'
import { Checkbox, checkboxVariants } from '../forms/checkbox'
import { cn } from '../helpers/classnames'
import { cx } from '../helpers/classnames'

interface ExpandableCheckboxProps {
  description: string
  checked: boolean
  label: string
  onChange: (is_active: boolean) => void
  children?: React.ReactNode
  brandKit?: boolean
  defaultChecked?: boolean
  size?: 'sm' | 'base' | 'lg' | 'xl'
  classNames?: {
    wrapper?: string
    checkbox?: string
  }
}

const CheckboxCard = ({
  description,
  checked,
  label,
  onChange,
  brandKit = false,
  defaultChecked,
  size = 'base',
  classNames,
}: ExpandableCheckboxProps) => {
  return (
    <div className={cn('w-fulloverflow-hidden')}>
      <div
        className={cn(
          'rounded-lg flex items-start  space-x-2 p-2 cursor-pointer bg-neutral-50/75 dark:bg-neutral-900/40 backdrop-blur-md border-black/5 border-2 dark:border-white/10 backdrop:transition-colors '
        )}
        onClick={() => onChange(!checked)}
      >
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(!checked)}
          onClick={(e) => e.stopPropagation()}
          label=""
          brandKit={brandKit}
        />
        <div className="flex justify-between w-full">
          <div className="flex flex-col">
            <div className="text-base font-semibold dark:text-white ">
              {label}
            </div>
            <div className="text-sm text-gray-600 dark:text-white">
              {description}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { CheckboxCard }
